import { render } from "./ElementsAmountInput.vue?vue&type=template&id=639c29d8&scoped=true"
import script from "./ElementsAmountInput.vue?vue&type=script&lang=js"
export * from "./ElementsAmountInput.vue?vue&type=script&lang=js"

import "./ElementsAmountInput.vue?vue&type=style&index=0&id=639c29d8&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/PRD_sharetreats_v1_hr_company_dashboard_client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-639c29d8"]])

export default __exports__